export const styles = {
  tableCard:
    "bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-y-auto sm:overflow-y-auto",
  container:
    "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4",
  header: "px-0 py-1",
  title: "text-theme-xl font-semibold text-gray-800 dark:text-white/90",
  headerControls:
    "flex flex-col md:flex-row justify-between items-center p-4 border-b border-white dark:border-gray-700 bg-white dark:bg-gray-800 gap-4 md:gap-6",
  controlsInner:
    "flex flex-wrap md:flex-nowrap items-center w-full md:w-auto gap-2 md:gap-2",
  searchContainer: "relative flex items-center flex-1 w-full md:w-auto h-10",
  searchInput:
    "dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pl-11 pr-4 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 md:w-[180px] xl:w-[200px]",
  searchIcon: "absolute left-3 text-gray-400 dark:text-gray-300 w-4 h-4",
  downloadButton:
    "inline-flex items-center justify-center rounded-lg transition px-4 py-2 md:py-3 text-sm bg-white text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-400 dark:ring-gray-700 dark:hover:bg-white/[0.03] dark:hover:text-gray-300",
  downloadIcon: "w-5 h-5 ml-2",
  errorText: "text-red-500 text-xs",
  tableContainer: "overflow-x-auto max-h-[500px] block",
  table: "w-full border-collapse table-auto min-w-[600px] border-separate border-spacing-0",
  theadRow: "sticky top-0 z-10 bg-white dark:bg-gray-900 text-left font-medium text-gray-700 theme-xs dark:text-gray-400 border-b border-gray-300 dark:border-gray-700",
  thName:
    "min-w-[100px] md:min-w-[120px] px-3 py-2 md:px-4 md:py-3 border border-gray-100 dark:border-white/[0.05]",
  thEmail:
    "min-w-[150px] md:min-w-[180px] px-3 py-2 md:px-4 md:py-3 border border-gray-100 dark:border-white/[0.05]",
  thMobileNumber:
    "min-w-[120px] md:min-w-[140px] px-3 py-2 md:px-4 md:py-3 border border-gray-100 dark:border-white/[0.05]",
  thRole:
    "min-w-[80px] md:min-w-[100px] px-3 py-2 md:px-4 md:py-3 border border-gray-100 dark:border-white/[0.05]",
  thAction:
    "w-[100px] md:w-[150px] px-2 py-2 md:px-4 md:py-3 border border-gray-100 dark:border-white/[0.05] text-xs md:text-sm",
  thSortable: "flex items-center justify-between cursor-pointer",
  thText:
    "font-bold text-gray-800 text-theme-xs md:text-sm dark:text-gray-400",
     thTexts:
    "px-2 py-2 md:px-4 md:py-3 border border-gray-100 dark:border-white/[0.05] text-xs md:text-sm",
  sortButton: "flex flex-col gap-0.5",
  tbodyRow: "border border-gray-100 dark:border-white/[0.05]",
  tdName:
    "px-2 py-2 md:px-4 md:py-4 font-normal text-gray-800 dark:text-gray-400 text-theme-sm md:text-theme-sm border border-gray-100 dark:border-white/[0.05] max-w-[160px] md:max-w-[200px] break-words",
  tdEmail:
    "px-2 py-2 md:px-4 md:py-4 font-normal text-gray-800 dark:text-gray-400 text-sm md:text-theme-sm border border-gray-100 dark:border-white/[0.05] max-w-[180px] md:max-w-[220px] break-words",
  tdMobileNumber:
    "px-2 py-2 md:px-4 md:py-4 font-normal text-gray-800 dark:text-gray-400 text-sm md:text-theme-sm border border-gray-100 dark:border-white/[0.05] max-w-[140px] md:max-w-[160px] break-words",
  tdRole:
    "px-2 py-2 md:px-4 md:py-4 font-normal text-gray-800 dark:text-gray-400 text-sm md:text-theme-sm border border-gray-100 dark:border-white/[0.05] max-w-[100px] md:max-w-[120px] break-words",
  tdAction:
    "w-[70px] md:w-[120px] px-2 py-2 md:px-4 md:py-4 border border-gray-100 dark:border-white/[0.05]",
  viewButton:
    "shrink-0 w-6 h-6 bg-green-600 dark:bg-green-500 flex items-center justify-center rounded-md shadow hover:bg-green-400 dark:hover:bg-green-500 transition",
  actionContainer: "flex justify-start items-center space-x-1.5",
  loadingRow: "border border-gray-100 dark:border-white/[0.05]",
  noDataText: "text-center text-gray-500 dark:text-gray-400 py-4 !border-0",
};